import { Card, Col, Row } from "antd"
import React, { useEffect, useState } from "react"
import ProfileForm from "../../../components/dashboard/ProfileForm"
import { apiUrl } from "../../../utils/api"
import { get } from "../../../utils/axios"

const Profile = () => {
  const [profile, setProfile] = useState({})

  useEffect(() => {
    get(`${apiUrl}/profile`).then((x) => setProfile(x.data))
  }, [])
  return (
    <Row>
      <Col span={8}>
        <Card title="Profil">
          <ProfileForm profile={profile} />
        </Card>
      </Col>
    </Row>
  )
}

export default Profile
